// COMMON MESSAGES
export const UNKNOWN_ERROR_OCCURED = "Unknown Error occured! Please try again"
export const ERROR_WHILE__NAME = "Error occured in API -"
// example:- console.log(`${ERROR_WHILE__NAME} apiName `, err.message)

// PRODUCTS PAGES
export const ERROR_WHILE_FETCHING_PRODUCTS = "Unable to load Products. Please try again."

// edit
export const CUSTOMER_UPDATED_SUCCESSFULLY = "Changes Saved"
export const ERROR_WHILE_UPDATING_CUSTOMER = "Unable to save your details. please try again"

export const CUSTOMER_PASSWORD_UPDATED_SUCCESSFULLY = "Password updated successfully"
export const ERROR_WHILE_UPDATING_CUSTOMER_PASSWORD = "Unable to update password. please try again"

//ADD CUSTOMER 
export const ERROR_WHILE_FETCHING_ADDRESS = "Unable to load Customers. Please try again."
export const ERROR_WHILE_DELETING_ADDRESS = "No details found."
export const CONFIRMATION_BEFORE_DELETING_ADDRESS = "Are you sure you want to delete this address?"
export const ADDRESS_DELETED_SUCCESSFULLY = "Address deleted successfully."
export const SET_ADDRESS_DEFAULT_SUCCESSFULLY = "Set Address as default successfully."
export const ERROR_WHILE_SET_ADDRESS_DEFAULT = "Error occured!! Please check if all the required fields are filled correctly."

// create address
export const ADDRESS_ADDED_SUCCESSFULLY = "Address added successfully."
export const ERROR_WHILE_CREATING_ADDRESS = "Error occured!! Please check if all the required fields are filled correctly."

// edit address
export const ADDRESS_UPDATED_SUCCESSFULLY = "Address Updated successfully."
export const ERROR_WHILE_UPDATING_ADDRESS = "Error occured!! please check if all the required fields are filled correctly."
export const ERROR_WHILE_GETTING_ADDRESS_DETAILS = "Unable to get the address details. Please try again"


// EMAILS PAGES
export const ERROR_WHILE_FETCHING_EMAILS = "Unable to load Email Templates. Please try again."
export const ERROR_WHILE_DELETING_EMAIL = "No details found."
export const CONFIRMATION_BEFORE_DELETING_EMAIL = "Are you sure you want to delete this email template?"
export const EMAIL_DELETED_SUCCESSFULLY = "Email Template deleted successfully."
// create
export const EMAIL_ADDED_SUCCESSFULLY = "Email created successfully."
export const ERROR_WHILE_CREATING_EMAIL = "Error occured!! Please check if all the required fields are filled correctly."
// // edit
export const EMAIL_UPDATED_SUCCESSFULLY = "Email Updated successfully."
export const ERROR_WHILE_UPDATING_EMAIL = "Error occured!! please check if all the required fields are filled correctly."
export const ERROR_WHILE_GETTING_EMAIL_DETAILS = "Unable to get the emails details. Please try again"


// BLOGS PAGES
export const ERROR_WHILE_FETCHING_BLOGS = "Unable to load Blogs. Please try again."
export const ERROR_WHILE_DELETING_BLOG = "No details found."
export const CONFIRMATION_BEFORE_DELETING_BLOG = "Are you sure you want to delete this blog?"
export const BLOG_DELETED_SUCCESSFULLY = "Blog deleted successfully."
// create
export const BLOG_ADDED_SUCCESSFULLY = "Blog created successfully."
export const ERROR_WHILE_CREATING_BLOG = "Error occured!! Please check if all the required fields are filled correctly."
// // edit
export const BLOG_UPDATED_SUCCESSFULLY = "Blog Updated successfully."
export const ERROR_WHILE_UPDATING_BLOG = "Error occured!! please check if all the required fields are filled correctly."
export const ERROR_WHILE_GETTING_BLOG_DETAILS = "Unable to get the blog detail. Please try again"


// CUSTOMER GROUPS PAGES
export const ERROR_WHILE_FETCHING_CUSTOMERGROUPS = "Unable to load Customer Groups. Please try again."
export const ERROR_WHILE_DELETING_CUSTOMERGROUP = "No details found."
export const CONFIRMATION_BEFORE_DELETING_CUSTOMERGROUP = "Are you sure you want to delete this customer group?"
export const CUSTOMERGROUP_DELETED_SUCCESSFULLY = "Customer Group deleted successfully."
// create
export const CUSTOMERGROUP_ADDED_SUCCESSFULLY = "Customer Group created successfully."
export const ERROR_WHILE_CREATING_CUSTOMERGROUP = "Error occured!! Please check if all the required fields are filled correctly."
// // edit
export const CUSTOMERGROUP_UPDATED_SUCCESSFULLY = "Customer Group Updated successfully."
export const ERROR_WHILE_UPDATING_CUSTOMERGROUP = "Error occured!! please check if all the required fields are filled correctly."
export const ERROR_WHILE_GETTING_CUSTOMERGROUP_DETAILS = "Unable to get the customer group detail. Please try again"

// VARIATIONS PAGES
// create
export const VARIATIONS_ADDED_SUCCESSFULLY = "Variation added successfully."
export const ERROR_WHILE_CREATING_VARIATIONS = "Error occured!! Please try again."

// Multipliers
export const MULTIPLIERS_UPDATED_SUCCESSFULLY = "Multipliers added successfully."
export const ERROR_WHILE_FETCHING_MULTIPLIERS = "Unable to load Multipliers. Please try again."

// Product Multipliers
export const PRODUCT_MULTIPLIERS_UPDATED_SUCCESSFULLY = "Product Multipliers Updated successfully."
export const ERROR_WHILE_UPDATING_PRODUCT_MULTIPLIERS = "Error occured!! please check if all the required fields are filled correctly."

// Brand Multipliers
export const BRAND_MULTIPLIERS_UPDATED_SUCCESSFULLY = "Brand Multipliers Updated successfully."
export const ERROR_WHILE_UPDATING_BRAND_MULTIPLIERS = "Error occured!! please check if all the required fields are filled correctly."

// Category Multipliers
export const CATEGORY_MULTIPLIERS_UPDATED_SUCCESSFULLY = "Category Multipliers Updated successfully."
export const ERROR_WHILE_UPDATING_CATEGORY_MULTIPLIERS = "Error occured!! please check if all the required fields are filled correctly."

//Quickbook Settings
export const QUICKBOOKS_SETTINGS_UPDATED_SUCCESSFULLY = "Settings updated successfully."
export const ERROR_WHILE_FETCHING_QUICKBOOKS_SETTINGS = "Unable to load settings. Please try again."

// VENDORS PAGES
export const ERROR_WHILE_FETCHING_VENDORS = "Unable to load Vendors. Please try again."
export const ERROR_WHILE_DELETING_VENDORS = "No details found"
export const CONFIRMATION_BEFORE_DELETING_VENDOR = "Are you sure you want to delete this vendor?"
export const VENDOR_DELETED_SUCCESSFULLY = "Vendor is deleted successfully."
// create
export const VENDOR_ADDED_SUCCESSFULLY = "Vendor created successfully."
export const ERROR_WHILE_CREATING_VENDOR = "Error occured!! Please check if all the required fields are filled correctly."
// edit
export const VENDOR_UPDATED_SUCCESSFULLY = "Vendor Updated successfully."
export const ERROR_WHILE_UPDATING_VENDOR = "Error occured!! please check if all the required fields are filled correctly."
export const ERROR_WHILE_GETTING_VENDOR_DETAILS = "Unable to get the vendor details. Please try again"

// Cart PAGES
export const ERROR_WHILE_FETCHING_CART = "Unable to load Cart. Please try again."
export const ERROR_WHILE_DELETING_CART = "No details found"
export const CONFIRMATION_BEFORE_DELETING_CART = "Are you sure you want to delete this cart?"
export const CART_DELETED_SUCCESSFULLY = "Cart is deleted successfully."
// create
export const CART_ADDED_SUCCESSFULLY = "Cart created successfully."
export const ERROR_WHILE_CREATING_CART = "Error occured!! Please check if all the required fields are filled correctly."
// edit
export const CART_UPDATED_SUCCESSFULLY = "Cart Updated successfully."
export const ERROR_WHILE_UPDATING_CART = "Error occured!! please check if all the required fields are filled correctly."
export const ERROR_WHILE_GETTING_CART_DETAILS = "Unable to get the vendor details. Please try again"

//create coupon
export const COUPON__ADDED_SUCCESSFULLY = "Coupon created successfully."
export const ERROR_WHILE_CREATING__COUPON = "Error occured!! Please check if all the required fields are filled correctly."

// CART PAGE
export const ADDED_TO_CART_SUCCESSFULLY = "Item succesfully added to your cart"
export const UPDATED_TO_CART_SUCCESSFULLY = "Cart updated successfully"
export const ERROR_WHILE_SAVING_PRODUCT_TO_CART = "Unknow error occured while updating the cart. please try again"
export const DELETED_FROM_CART_SUCCESSFULLY = "Item deleted succesfully"
export const ERROR_WHILE_DELETING_PRODUCT_TO_CART = "Unknow error occured while deleting. please try again"

// newly created
export const LOGIN_SUCCESS = "You are successfully logged in"
export const COMBINATION_NOT_AVAILABLE = "Product with the selected options is not available"
export const COMBINATION_OUT_OF_STOCK = "This combination of options you are selecting is not available. please choose different options."

// orders
export const ERROR_WHILE_GETTING_ORDER_DETAILS = "Unable to get order details. Please try again."